import React, { useState, useEffect} from "react";
import MenuItemComponent from "./MenuItemComponent";
import ModalMenuItem from "./ModalMenuItem";

const ClickableMenuItem = ({ item, menu }) => {
  const [ isOpen, setIsOpen ] = useState( false );

  const handleClick = () => {
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <>
      <div onClick={handleClick}>
        <MenuItemComponent item={ item } menu={ menu }  />
      </div>
      {isOpen && (
        <ModalMenuItem menu={menu} item={item} onClose={handleClose} />
      )}
    </>
  );
};

export default ClickableMenuItem;
